import vuetify from "~/plugins/vuetify"
import router from "~/router"
import alert from "~/plugins/sweatalert"
import notification from "@kyvg/vue3-notification"
import { createPinia } from "pinia"
import { piniaIndexedDBPlugin } from "~/plugins/pinia-idb"
import { bindDateFilterPersistence } from "~/stores/date-filter.store"
import type { App } from "vue"

const pinia = createPinia()
pinia.use(piniaIndexedDBPlugin)

export function registerPlugins(app: App) {
    app.use(vuetify)
    app.use(router)
    app.use(alert)
    app.use(notification)
    app.use(pinia)
    bindDateFilterPersistence()
}

window.__router__ = router
window.__pinia__ = pinia
